import { ReactNode, useState } from "react";
import { Calendar } from "react-multi-date-picker";
import { Box, Popover, TextField } from "../../components";
import { getDelimitedString } from "../../services";
import { ValidationErrors } from "../../hooks";
import { displayErrorMessages, getErrorMessages } from "./input-functions";

export const MultiDatePicker = (props: {
  value?: Date[] | undefined;
  onChange?: (selectedDates: Date[] | undefined) => void;
  label?: ReactNode;
  required?: boolean;
  errors?: ValidationErrors | string[];
}) => {
  const DATE_FORMAT: string = "MM/DD/YYYY";
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const errorMsg = getErrorMessages(props.errors);
  const hasError = errorMsg?.length > 0 ? true : false;

  const handleChange = (values) => {
    if (values && props.onChange) {
      props.onChange(values.map((x) => x.format(DATE_FORMAT)));
    }

    return null;
  };

  const getDisplayValue = (values: Date[] | undefined): string | undefined => {
    if (values) {
      return getDelimitedString(
        values.map((x) => x.toString()),
        ", "
      );
    }

    return undefined;
  };

  return (
    <Box>
      <TextField
        label={props.label}
        fullWidth
        required={props.required}
        error={hasError}
        helperText={displayErrorMessages(errorMsg)}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        autoComplete="off"
        value={getDisplayValue(props.value) || ""}
        multiline
      />
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Calendar
          multiple
          value={props.value}
          onChange={handleChange}
          format={DATE_FORMAT}
          // format="Date:MM/DD/YYYY, Time:HH:mm:ss"
          // formattingIgnoreList={["Date", "Time"]}
        />
      </Popover>
    </Box>
  );
};
